import DetailAssetPurchase from "./detail-asset-purchase.vue";
import Vue from "vue";

export const events = new Vue({
  name: "detail-asset-purchase-events",
});

export default {
  install(Vue, args = {}) {
    Vue.component(args.componentName, DetailAssetPurchase);

    let params = args;

    let check = (params) => {
      // define emit name to detail-asset-events
      events.$emit("open", params);
    };

    const name = "detailPurchase";
    Vue.prototype["$" + name] = check;
    Vue[name] = check;
  },
};
